import React, { FunctionComponent, useEffect, ReactNode } from 'react'
import clsx from 'clsx'

import { ToastProvider, useIsBreakpointLargeAndUp, useThemeClass } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { stopDatadogSession } from '@afterpaytouch/integrations/datadog'
import { CHECKOUT_FLOW_TYPE, postCheckoutFlowMessage } from '../../integrations/inappbrowser-messenger'
import { SessionIdContainer } from '..'

interface AppContainerProps {
  children: ReactNode
  hasMargin?: boolean
  hasMobileTopMargin?: boolean
  lockScroll?: boolean
  isCashAuthLayout?: boolean
}

export const AppContainer: FunctionComponent<AppContainerProps> = ({
  children,
  hasMargin = true,
  hasMobileTopMargin = true,
  lockScroll = false,
  isCashAuthLayout = false,
}) => {
  const isDesktop = useIsBreakpointLargeAndUp() ?? false
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const themeClass = useThemeClass()

  const classNames = clsx(
    styles.container,
    hasMargin && styles.horizontalPadded,
    !isDesktop && !hasMobileTopMargin && styles.mobileNoTopMargin,
    lockScroll && styles.lockScroll,
    isCashAuthLayout && styles.isCashAuthLayout,
    styles[themeClass]
  )

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent): void => {
      logEvent(TrackingEvent.PRESSED_CLOSE_BROWSER_TAB, { pressedCloseBrowserTab: true })
      postCheckoutFlowMessage(CHECKOUT_FLOW_TYPE.ON_CHECKOUT_UNLOAD)
      stopDatadogSession()
      delete e.returnValue
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return (
    <div className={classNames}>
      <ToastProvider>{children}</ToastProvider>
      <SessionIdContainer />
    </div>
  )
}
